import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PlusCircleIcon from '../../../../../components/icons/PlusCircleIcon';
import Angle from '../../../../../components/global/Angle';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const AddressListItemAddButton = ({ className, onClick }) => {
  const classes = classNames({
    'address-list-action-button': true,
    'address-list-item-add-button': true,
    [className]: !!className,
  });

  return (
    <button className={classes} onClick={onClick}>
      <PlusCircleIcon /> Add new address
      <Angle direction="right" />
    </button>
  );
};

AddressListItemAddButton.propTypes = propTypes;

export default AddressListItemAddButton;
